import React from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact } from "higher-order-components"
import { SpecificationList } from "containers"
import { Heading } from "components"
import { Interactive, P } from "AtomicComponents";

const Desc = ({ name, value }) => (
  <div
    style={{
      padding: "1em",
      textAlign: "left",
      boxSizing: "border-box"
    }}>
    {value && <Interactive>{name}</Interactive>}
    {value && <P withoutMargin>{value}</P>}
  </div>
)

Desc.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string
}

const VehicleSpecifications = ({
  specifications,
  exterior,
  grade,
  interior,
  bodyStyle,
  driveTransmission,
  engine,
  compact
}) => (
  <div>
    <div style={styles.details(compact)}>
      <div
        style={{
          flexBasis: "33%",
          flexGrow: 1,
          flexShrink: 1
        }}>
        <Desc name="Grade" value={grade} />
        <Desc name="Engine" value={engine} />
      </div>
      <div
        style={{
          flexBasis: "33%",
          flexGrow: 1,
          flexShrink: 1
        }}>
        <Desc name="Body" value={bodyStyle} />
        <Desc name="Exterior" value={exterior} />
      </div>
      <div
        style={{
          flexBasis: "33%",
          flexGrow: 1,
          flexShrink: 1
        }}>
        <Desc name="Drive & transmission" value={driveTransmission} />
        <Desc name="Interior" value={interior} />
      </div>
    </div>
    {specifications && <SpecificationList specs={specifications.data.categories} />}
  </div>
)

const styles = {
  details: compact => ({
    display: compact ? "block" : "flex",
    justifyContent: "space-around",
    fontSize: "95%",
    padding: "2em 0"
  })
}

VehicleSpecifications.propTypes = {
  exterior: PropTypes.string.isRequired,
  grade: PropTypes.string.isRequired,
  interior: PropTypes.string.isRequired,
  bodyStyle: PropTypes.string.isRequired,
  driveTransmission: PropTypes.string.isRequired,
  engine: PropTypes.string.isRequired,
  compact: PropTypes.bool,
  specifications: PropTypes.shape({
    data: PropTypes.shape({
      categories: PropTypes.array,
      disclaimers: PropTypes.array
    })
  })
}

export default withRadium(DetectCompact())(VehicleSpecifications)

/**
 * @typedef {Object} BackHyperlink
 * @property {String} name - Displayed Name.
 * @property {String} href - Hyperlink href.
 */



// WEBPACK FOOTER //
// ./src/components/mymazda/vehicle-specs/index.jsx